<template>
  <v-container class="pa-0">
    <message-box
      v-model="warningMessage.open"
      title="Zrušiť prípad"
      text="Naozaj chcete zrušiť tento prípad?"
      :action="cancelPripad"
      persistent
      yes-no
    />
    <div class="d-flex my-18px">
      <h2 class="noselect">Obchodné prípady</h2>
      <v-btn to="/obchodne-pripady" :ripple="false" class="btn-primary link ml-auto mr-n3"
        >Všetky prípady</v-btn
      >
    </div>
    <div class="dash-container-body">
      <v-row no-gutters class="mx-n4" v-if="!isLoading">
        <v-col v-for="(item, index) in data" :key="index" xl="3" lg="3" md="3" class="px-4">
          <v-card class="pa-5 card-item-dark">
            <div>
              <Status :state="item.stav" class="mb-3"></Status>
              <Status v-if="item.rozpracovany" :state="0" class="mb-3 right">Rozpracovaný</Status>
            </div>
            <div>
              <span class="f12 gs100">{{ item.datum_modifikacie.formatDate() }}</span>
              <span class="f14 bold right mt-3px">{{ item.cislo_obch_pripadu }}</span>
            </div>
            <!-- <text-group
              :utext="item.datum_vytvorenia.formatDate()"
              :btext="item.cislo_obch_pripadu"
              large
            ></text-group> -->
            <text-group
              class="mt-12px btext-fixed-height"
              utext="Nájomca"
              :btext="item.najomca"
              smallHeader
            ></text-group>
            <v-divider class="my-8px"></v-divider>
            <div class="d-flex">
              <text-group
                utext="Modifikoval"
                :btext="item.modifikoval ? item.modifikoval : '-'"
                smallHeader
                class="w100"
              ></text-group>
            </div>
            <v-divider class="my-8px"></v-divider>
            <v-tooltip top :close-delay="0" :open-delay="200" v-if="getMenu(item, 'edit_pripad').is_visible">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="redirectToEditPripad(item.new_id)"
                  icon
                  small
                  tile
                  outlined
                  :disabled="getMenu(item, 'edit_pripad').is_enabled === 0"
                  v-on="on"
                  class="mr-3 btn-secondary"
                >
                  <v-icon size="18"> mdi-pencil-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ getMenu(item, 'edit_pripad').display_member }}</span>
            </v-tooltip>

            <v-tooltip top :close-delay="0" :open-delay="200" v-if="getMenu(item, 'pridat_dokumenty_pripad').is_visible">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  small
                  tile
                  class="mr-3"
                  v-on="on"
                  :disabled="getMenu(item, 'pridat_dokumenty_pripad').is_enabled === 0"
                  @click="redirectToUploadDokumentov(item.new_id, '0', '', 'dashboard')"
                >
                  <v-icon size="18"> mdi-upload-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ getMenu(item, 'pridat_dokumenty_pripad').display_member }}</span>
            </v-tooltip>

            <v-tooltip top :close-delay="0" :open-delay="200" v-if="getMenu(item, 'tlacit_pripad').is_visible">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  small
                  tile
                  v-on="on"
                  class="mr-3"
                  :disabled="getMenu(item, 'tlacit_pripad').is_enabled === 0"
                  @click="redirectToTlacDokumentov(item.new_id)"
                >
                  <v-icon class="material-icons-outlined" size="18"> print </v-icon>
                </v-btn>
              </template>
              <span>{{ getMenu(item, 'tlacit_pripad').display_member }}</span>
            </v-tooltip>

            <v-tooltip top :close-delay="0" :open-delay="200" v-if="getMenu(item, 'sumar').is_visible">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  small
                  tile
                  class="mr-3"
                  v-on="on"
                  :disabled="getMenu(item, 'sumar').is_enabled === 0"
                  @click="redirectToSumarPredmet(item.new_id)"
                >
                  <v-icon class="material-icons-outlined icon-block" size="20"> summarize </v-icon>
                </v-btn>
              </template>
              <span>{{ getMenu(item, 'sumar').display_member }}</span>
            </v-tooltip>

            <v-tooltip top :close-delay="0" :open-delay="200" v-if="getMenu(item, 'edit_stav').is_visible">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  small
                  tile
                  class="mr-3"
                  v-on="on"
                  :disabled="getMenu(item, 'edit_stav').is_enabled === 0"
                  @click="openCancelWarning(item.new_id)"
                >
                  <v-icon size="18"> mdi-checkbox-blank-circle-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ getMenu(item, 'edit_stav').display_member }}</span>
            </v-tooltip>
          </v-card>
        </v-col>
      </v-row>
      <div class="text-center" v-else>
        <v-progress-circular :size="50" indeterminate></v-progress-circular>
      </div>
    </div>
  </v-container>
</template>
<script>
import protectedAxios from '../../auth/axios';
import Status from '../../components/basic/Status';
import TextGroup from '../basic/TextGroup.vue';
import { pripadLinkMixin } from '../../mixins/pripadLinkMixin';
import { pripadActionsMixin } from '../../mixins/pripadActionsMixin';

import MessageBox from '../basic/MessageBox.vue';

export default {
  mixins: [pripadLinkMixin, pripadActionsMixin],
  components: { Status, TextGroup, MessageBox },
  data() {
    return {
      data: [],
      isLoading: false,
      btnEdit: {},
      btnDokumenty: {},
      btnDuplikovat: {},
      btnZrusit: {},
    };
  },
  methods: {
    getMenu(item, valueMember) {
      let menufiltered = item.menu.filter(m => m.value_member === valueMember);
      if (menufiltered.length > 0) {
        return menufiltered[0];
      }
      return {};
    },
    reloadData() {
      this.isLoading = true;
      protectedAxios
        .get('pripady/dashboard')
        .then(res => {
          this.isLoading = false;
          this.data = res.data;
        })
        .catch(e => {
          console.error(e);
          this.data = [];
        });
    },
  },
  mounted() {
    this.reloadData();
  },
};
</script>
<style lang="sass">
.btext-fixed-height
  .btext
    height: 34px
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
    overflow: hidden
</style>
